export default __webpack_public_path__ + "static/BannerGenericImageTextTitle_InfoOverlay-8996ea9fafa2610a1200c8f16bc812b6.jpg";